import { makeClients } from './algolia-helpers';
import useOnce from '@scentregroup/shared/hooks/use-once';
export function useAlgoliaClients(algoliaApiKeys) {
  return useOnce(() => makeClients(algoliaApiKeys));
}